export const FLOAT = /^[-]?\d*(\.\d{0,2})?$/;
export const DECIMAL_MAX_TWO_FRACTIONS = /^[-]?\d*(\.\d{0,2})?$/;
